// 업체 발신번호 등록 요청 콜러블 — 환경 설정 「보호자 알림 보내는 번호」에서 쓴다
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

const _req = httpsCallable<{ phone: string }, { ok: boolean; notified: boolean }>(functions, "requestSenderRegistration");

/** 등록할 번호를 보내면 콕소프트 대표 번호로 요청 문자가 간다. 서류 안내·등록은 사람이 한다 */
export async function requestSenderRegistration(phone: string) {
  return (await _req({ phone })).data;
}
